import { action } from 'satcheljs';

export const removeDomain = action('removeDomain');
